import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { MetadataService } from '../../metadata.service';
import { TreeclassifierComponent } from '../treeclassifier/treeclassifier.component';
import { GSPMetadataService } from '../../../metadata.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-metadatapackageselect',
  templateUrl: './metadatapackageselect.component.html',
  styleUrls: ['./metadatapackageselect.component.css']
})
export class MetadatapackageselectComponent implements OnInit {
  @Output() closeModalEmitter: EventEmitter<any>;
  @ViewChild(TreeclassifierComponent) treeclassifierComponent: TreeclassifierComponent;
  constructor(private metadataService: MetadataService,
              private gspMetaService: GSPMetadataService) { this.closeModalEmitter = new EventEmitter<any>(); }
  ngOnInit() {
  }

  showModal(): void {
    // this.isModalShown = true;
  }

  hideModal(): void {
    // this.isModalShown = false;
    this.closeModalEmitter.emit();
  }

  onHidden(): void {
    // this.isModalShown = false;
    this.closeModalEmitter.emit();
  }

  onSelectedChange(classifier: string) {
    // this.classifier = classifier;
  }

  ResolvePackage() {
    this.closeModalEmitter.emit();
    if (this.metadataService.packages.length > 0) {
      let flag = false;
      const packageName = this.metadataService.packages[0];
      this.gspMetaService.GetDevRootPath().subscribe(root => {
        this.metadataService.rootPath = root;
        this.metadataService.GetMetadataPackageInfo(root + this.metadataService.packRefPath, packageName).subscribe(packageInfo => {
          const header = packageInfo.header;
          // 检测依赖项
          this.metadataService.GetMetadataProjectInfo().subscribe(projInfo => {
            // 已有依赖关系
            const refs = projInfo.metadataPackageRefs;
            refs.forEach(item => {
              if (item.name === header.name) {
                alert('已添加对该元数据包的依赖');
                flag = true;
              }
            });
            if (flag === true) {
              return;
            }
          // 更新工程引用
            this.metadataService.UpdateMetadataProject(header).subscribe(data => {
            this.metadataService.treeData = [];
            this.metadataService.Refresh();
          });
          // 刷新树节点
            if (this.treeclassifierComponent) {
            this.treeclassifierComponent.files = this.metadataService.treeData;
           }
            });
        });
      });
    }
  }
}
